import { Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Consent, IntakeService } from '@mmx/shared'

import { ConsentTermsDialogComponent } from '../../dialogs/consent-terms/consentTerms.dialog.component'
import { TermsDialogComponent } from '../../dialogs/terms-dialog/terms-dialog.component'

@Component({
  selector: 'mmx-consents',
  templateUrl: './consents.component.html',
  styleUrls: ['./consents.component.scss'],
  standalone: false,
})
export class ConsentsComponent implements OnInit {
  acceptedTerms: boolean
  hasGuarantorChecked: boolean
  consents: Consent[]
  consented: { [key: string]: boolean } = {}

  constructor(
    private dialog: MatDialog,
    private intakeService: IntakeService,
  ) {}

  ngOnInit() {
    this.acceptedTerms = this.intakeService.data.acceptedTerms
    this.hasGuarantorChecked = this.intakeService.data.hasGuarantor
    this.consented = this.intakeService.data.consented
    this.consents = this.intakeService.consents
  }

  openConsents(consent) {
    const dialogRef = this.dialog.open(ConsentTermsDialogComponent, {
      data: {
        acceptable: true,
        consent,
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.consented[result] = true
      }
    })
  }

  openTerms() {
    const dialogRef = this.dialog.open(TermsDialogComponent, {
      data: {
        acceptable: true,
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.acceptedTerms = true
      }
    })
  }
}
